import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";
import { IconComponent } from "src/icons";
import IconLink from "src/icons/IconLink";
import IconLocation from "src/icons/IconLocation";

// Keeping these lookups generic for backwards compatibility with new variants

export const DEFAULT_ADDON_COLORS: Record<string, string> = {
	[AddonVariant.Link]: "#2B303B",
	[AddonVariant.Spotify]: "#1FC16BB2",
	[AddonVariant.Venmo]: "#3D92F7B2",
	[AddonVariant.Location]: "#3D43F7B2",
};

export const DEFAULT_ADDON_ICONS: Record<string, IconComponent | string> = {
	[AddonVariant.Link]: IconLink,
	[AddonVariant.Spotify]: "https://d2ghhd0yq7m3v1.cloudfront.net/resources/icons/spotify.png",
	[AddonVariant.Venmo]: "https://d2ghhd0yq7m3v1.cloudfront.net/resources/icons/venmo.png",
	[AddonVariant.Location]: IconLocation,
};

export const ADDON_TITLE_CHAR_LIMIT = 13;
